import {
  FETCH_COMPANIES,
  ADD_COMPANY,
  DELETE_COMPANY
} from "./types";
import {simpleRequest} from "../newForms2/simpleRequest"

export function fetchCompaniesFromAPI() {
  return async function (dispatch) {
    const data = (await simpleRequest({url:`companies`, method:"get"})).data;
    const companies = data?.companies;
    return dispatch(getCompanies(companies));
  };
};
function getCompanies(companies) {
  return {
    type: FETCH_COMPANIES,
    companies
  };
};

export function addCompanyOnAPI(data){
  return async function (dispatch) {
    const response = await simpleRequest({url:`companies`, method:"post", data});
    const company = response.data && response.data.company;
    return dispatch(addCompany(company));
  }
};
function addCompany(company){
  return{
    type: ADD_COMPANY,
    company
  };
};

export function deleteCompanyFromAPI(id){
  return async function(dispatch){
    const response = await simpleRequest({url:`companies/${id}`, method:"delete"});
    const deleted = response.data && response.data.deleted;
    return dispatch(deleteCompany(deleted));
  }
};
function deleteCompany(deleted){
  return{
    type: DELETE_COMPANY,
    deleted
  };
};